import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "header-label" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "skeleton-row"
}
const _hoisted_6 = {
  key: 1,
  class: "no-data-row"
}

import { ref, computed, onMounted } from 'vue';
	import { useRoute, useRouter } from 'vue-router';
	import { AlertModel } from '@/models/loans';
	import { CreditPullTypes } from '@/types/annual-review';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'AlertsTable',
  props: {
    loanId: {},
    isLoading: { type: Boolean },
    alerts: {},
    borrowerCreditPullTypeId: {},
    coBorrowerCreditPullTypeId: {}
  },
  setup(__props: any) {

	const props = __props;

	const route = useRoute();
	const router = useRouter();

	const isLoading = computed<boolean>(() => props.isLoading);
	const alerts = computed<AlertModel[]>(() => props.alerts ?? []);

	const sortKey = ref('');
	const sortOrder = ref(1);

	const headers = computed(() => {
		const borrowerLabel =
			props.borrowerCreditPullTypeId === CreditPullTypes.ORIGINAL ? 'Borrower AR Status' : 'Borrower CR Status';

		const coBorrowerLabel =
			props.coBorrowerCreditPullTypeId === CreditPullTypes.ORIGINAL
				? 'Co-Borrower AR Status'
				: 'Co-Borrower CR Status';

		return [
			{ label: 'Alert', sortable: true, key: 'alertTypeId' },
			{ label: borrowerLabel, sortable: true, key: 'borrowerAlert.statusName' },
			{ label: coBorrowerLabel, sortable: true, key: 'coAlert.statusName' }
		];
	});

	const sortedAlerts = computed(() => {
		if (!sortKey.value) {
			return alerts.value; // no sorting, return original order
		}

		return [...alerts.value].sort((a, b) => {
			let valA = getNestedValue(a, sortKey.value);
			let valB = getNestedValue(b, sortKey.value);

			if (typeof valA === 'string') {
				valA = valA.toLowerCase();
			}

			if (typeof valB === 'string') {
				valB = valB.toLowerCase();
			}

			if (valA < valB) {
				return -1 * sortOrder.value;
			} else if (valA > valB) {
				return 1 * sortOrder.value;
			}
			return 0;
		});
	});

	const getNestedValue = (obj: any, path: string): any => {
		return path.split('.').reduce((acc, key) => acc?.[key], obj);
	};

	const sortBy = (key: string) => {
		if (sortKey.value === key) {
			if (sortOrder.value === 1) {
				sortOrder.value = -1; // second click, descending
			} else if (sortOrder.value === -1) {
				sortKey.value = ''; // third click, reset sort
				sortOrder.value = 1; // default sort order for the next click
			}
		} else {
			sortKey.value = key;
			sortOrder.value = 1; // first click, ascending
		}

		router.push({
			query: {
				...route.query,
				alertsSortKey: sortKey.value,
				alertsSortOrder: sortOrder.value.toString()
			},
			hash: route.hash
		});
	};

	const getSortArrow = (key: string) => {
		if (sortKey.value === key) {
			return sortOrder.value === 1 ? '▲' : sortOrder.value === -1 ? '▼' : ' ';
		}

		return '';
	};

	const isActiveSort = (key: string) => (sortKey.value === key ? 'active-sort' : '');

	function intializeSorting() {
		const querySortKey = route.query.alertsSortKey as string;
		const querySortOrder = parseInt(route.query.alertsSortOrder as string, 10);

		if (querySortKey) {
			sortKey.value = querySortKey;
		}

		if (!isNaN(querySortOrder) && (querySortOrder === 1 || querySortOrder === -1)) {
			sortOrder.value = querySortOrder;
		}
	}

	onMounted(async () => {
		intializeSorting();
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers.value, (header) => {
            return (_openBlock(), _createElementBlock("th", {
              key: header.key,
              class: _normalizeClass(isActiveSort(header.key)),
              onClick: ($event: any) => (sortBy(header.key))
            }, [
              _createElementVNode("span", _hoisted_3, [
                _createTextVNode(_toDisplayString(header.label) + " ", 1),
                (header.sortable)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(getSortArrow(header.key)), 1))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_2))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("td", { colspan: "3" }, null, -1)
            ]))]))
          : (sortedAlerts.value.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("td", {
                  colspan: "3",
                  class: "no-data"
                }, "No alerts found", -1)
              ]))]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(sortedAlerts.value, (alert) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: alert.alertTypeId,
                  class: "data-row"
                }, [
                  _createElementVNode("td", null, _toDisplayString(alert.alertName), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(alert.borrowerAlert.statusCssClass)
                    }, _toDisplayString(alert.borrowerAlert.statusName), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(alert.coAlert.statusCssClass)
                    }, _toDisplayString(alert.coAlert.statusName), 3)
                  ])
                ]))
              }), 128))
      ])
    ])
  ]))
}
}

})